/* Wyszukiwanie po kodzie produktu na stronie wynikow.

   Shopify indeksuje SKU tylko w podpowiedziach (/search/suggest.json).
   Zwykle /search?q=... tego nie robi, wiec klient wpisywal kod, widzial
   podpowiedz, klikal "Szukaj" i dostawal pustke. Gdy wynikow jest zero,
   dopytujemy podpowiedzi i pokazujemy to, co znalazly. */
(function () {
  var box = document.querySelector('[data-sku-szukaj]');
  if (!box) return;

  var fraza = (box.getAttribute('data-q') || '').trim();
  if (!fraza) return;

  var lista = box.querySelector('[data-sku-lista]');
  if (!lista) return;

  var korzen = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var adres =
    korzen.replace(/\/$/, '') +
    '/search/suggest.json?q=' +
    encodeURIComponent(fraza) +
    '&resources[type]=product&resources[limit]=12';

  var waluta = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
  var jezyk = document.documentElement.lang || 'pl';
  var slowoOd = box.getAttribute('data-od') || '';

  function kwota(v) {
    try {
      return new Intl.NumberFormat(jezyk, { style: 'currency', currency: waluta }).format(Number(v));
    } catch (e) {
      return Number(v).toFixed(2) + ' ' + waluta;
    }
  }

  function bezpieczny(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  fetch(adres, { headers: { Accept: 'application/json' } })
    .then(function (r) {
      return r.ok ? r.json() : null;
    })
    .then(function (d) {
      var produkty =
        d && d.resources && d.resources.results && d.resources.results.products;
      if (!produkty || !produkty.length) return;

      lista.innerHTML = produkty
        .map(function (p) {
          var zdj = (p.featured_image && p.featured_image.url) || p.image || '';
          var cena = '';
          if (p.price_min != null) {
            var zakres = p.price_max != null && Number(p.price_max) > Number(p.price_min);
            cena = (zakres && slowoOd ? slowoOd + ' ' : '') + kwota(p.price_min);
          }
          return (
            '<a class="sku-karta" href="' + bezpieczny(p.url) + '">' +
            '<span class="sku-foto">' +
            (zdj
              ? '<img src="' + bezpieczny(zdj) + '" alt="" loading="lazy" width="400" height="400">'
              : '') +
            '</span>' +
            '<span class="sku-tresc">' +
            (p.vendor ? '<span class="sku-marka">' + bezpieczny(p.vendor) + '</span>' : '') +
            '<span class="sku-nazwa">' + bezpieczny(p.title) + '</span>' +
            (cena ? '<span class="sku-cena">' + bezpieczny(cena) + '</span>' : '') +
            '</span>' +
            '</a>'
          );
        })
        .join('');

      box.hidden = false;
      var chowane = document.querySelectorAll('[data-sku-chowaj]');
      for (var i = 0; i < chowane.length; i++) chowane[i].hidden = true;
    })
    .catch(function () {});
})();
